import React from 'react';

function KomunikatorSingleContentEmpty(props) {

	return null;
}

export default KomunikatorSingleContentEmpty;